import { TweetsInfo } from "./TweetsLikes";
import { LikedByUser } from "./UserLikes";
const setTweetsWithUserLike = (likesArray: any, tweetsArray: any, userLikesArray: any, ) => {
    const likesPublicKeys = likesArray.map((likes: { account: { tweet: string }, publicKey: string }) => ({ tweetAddress: likes.account.tweet, likeAddress: likes.publicKey }));
    const tweetsWithLikes = TweetsInfo(tweetsArray, likesPublicKeys);
    // console.log("USER LIKES", userLikes);
    const userLikesPublicKeys = userLikesArray.map((userLikes: any) => userLikes.account.tweet.toString());
    // console.log("USER LIKED PUB KEYS---", userLikesPublicKeys);
    const tweetsWithUserLikes = LikedByUser(tweetsWithLikes, userLikesPublicKeys);
return tweetsWithUserLikes;
}

export default setTweetsWithUserLike;